import { ScreenPropAdminUserItem } from "~/navigation/Navigation.types";

import { AdminUserItem } from "./AdminUsers.Item";

export const AdminUserItemScreen = (props: ScreenPropAdminUserItem) => {
  return <AdminUserItem id={props.route.params.id} />;
};
